import { InjectionToken } from '@angular/core';

export interface FormsConfig {
  apiUrl: string;
  blobStorageUrl?: string;
  appInsightsConnectionString?: string;
}

export const FORMS_CONFIG = new InjectionToken<FormsConfig>('FORMS_CONFIG');
